import template from './template.html';
import controller from './controller';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.panel.phones', {
		url: '/phones',
		template: template,
		controller: controller,
		controllerAs: 'vm'
	});

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/phones.component/routes.js
 **/